import { Link } from 'react-router-dom'
import { formatDateTime } from '../../../../../../../../_metronic/helpers/crud-helper/helpers'
import { CriarRascunhoButton } from '../../../../acoes/CriarRascunhoButton'
import { SituacaoProtocoloBadge } from '../../../../components/SituacaoProtocoloBadge'
import { useAcoesModelo } from '../../../../core/useProtocoloAcoes'
import { CLASSE_LINK_OUTLINE } from '../../../../core/classeLinkOutline'
import { TableCard } from '../../../../../../../components/Table/TableCard'
import { InfoAlert } from '../../../../../../../components/Info/InfoAlert'
import { useVersoesModelo } from '../../core/useVersoesModelo'
import { rotaDetalheModelo } from '../../core/rotas'

/**
 * Cabeçalho da lista: a versão publicada em destaque (ou o aviso de que não há nenhuma), com a
 * ação de criar rascunho — o rascunho do modelo nasce da versão publicada.
 */
export const ModeloPlataformaListHeader = () => {
  const { acoesModelo } = useAcoesModelo()
  const { publicada, isLoading, isError } = useVersoesModelo()

  if (isLoading || isError) return null

  const criarRascunho = (
    <CriarRascunhoButton
      escopo='modeloPlataforma'
      podeCriarRascunho={acoesModelo.podeGerenciarModelo}
      rotulo='Criar rascunho da versão publicada'
      aparencia='principal'
    />
  )

  if (!publicada) {
    return (
      <div role='status'>
        <InfoAlert
          variant='warning'
          title='Nenhuma versão publicada do modelo'
          action={criarRascunho}
        >
          Sem versão publicada, as empresas não conseguem criar rascunho a partir do modelo Lauduz.
        </InfoAlert>
      </div>
    )
  }

  // Identificação à esquerda (título + data · hash · origem numa linha só) e ações à direita,
  // alinhadas ao título; em tela estreita as ações descem para baixo.
  return (
    <TableCard className='mb-6'>
      <section
        className='card-body d-flex flex-wrap justify-content-between align-items-center gap-6'
        aria-label='Versão publicada'
      >
        <div className='d-flex align-items-center gap-4 min-w-0'>
          <SituacaoProtocoloBadge situacao={publicada.situacao} escopo='modelo' />
          <div className='min-w-0'>
            <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
              Versão {publicada.versao} — {publicada.nome}
            </h3>
            <p className='mb-0 fs-7 text-gray-700'>
              {publicada.dtPublicacao && (
                <>Publicada em {formatDateTime(publicada.dtPublicacao)} · </>
              )}
              hash <code>{publicada.hash.slice(0, 12)}</code>
              {publicada.recursoCargaInicial && ' · Carga inicial'}
            </p>
          </div>
        </div>
        <div className='d-flex flex-wrap align-items-center gap-3'>
          <Link className={CLASSE_LINK_OUTLINE} to={rotaDetalheModelo(publicada.id)}>
            Ver detalhe
          </Link>
          {criarRascunho}
        </div>
      </section>
    </TableCard>
  )
}
